module.exports = __webpack_public_path__ + "img/10.c8c0e172.svg";